/* eslint-disable max-len */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { node } from 'prop-types';

const ProductPodLayout = ({
  leftColumn,
  rightColumn
}) => {
  return (
    <div className="sui-w-full">
      <div className="sui-w-[calc(100%_+_16px)] -sui-ml-2 sui-grid sui-grid-cols-12 sui-gap-4 md:sui-flex md:sui-flex-col md:sui-gap-2 md:sui-w-full md:sui-ml-0">
        <div className="sui-col-span-5 sui-relative sui-left-2 md:sui-left-0 sui-flex sui-justify-center sui-items-center">
          {leftColumn}
        </div>
        <div className="sui-col-span-7 sui-relative sui-left-2 sui-pr-4 md:sui-left-0 md:sui-pr-0">
          {rightColumn}
        </div>
      </div>
    </div>
  );
};

ProductPodLayout.defaultProps = {
  leftColumn: null,
  rightColumn: null
};

ProductPodLayout.propTypes = {
  leftColumn: node,
  rightColumn: node
};

export default ProductPodLayout;